import { ProgressBar } from "react-bootstrap";
import { Wager } from "../types";

interface WagerOutcomesProps {
  wager: Wager;
}

export default function WagerOutcomes(props: WagerOutcomesProps) {
  var wagerTotal = props.wager.bets.reduce((sum, bet) => sum + bet.total, 0);

  const getBetPercentage = (outcomeIndex) => {
    let betTotal = props.wager.bets
      .filter((bet) => bet.outcome === outcomeIndex)
      .reduce((sum, bet) => sum + bet.total, 0);
    var betPercentage = (betTotal / wagerTotal) * 100;
    if (isNaN(betPercentage)) betPercentage = 0;
    return betPercentage;
  };

  return (
    <>
      {props.wager.outcomes.map((outcome, index) => {
        let betPercentage = getBetPercentage(index);
        return (
          <div key={index}>
            <p>
              {outcome} ({Math.round(betPercentage)}%)
            </p>
            <ProgressBar now={betPercentage} />
          </div>
        );
      })}
    </>
  );
}
